import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { OperacionService } from '../../../services/formulacion/operacion.service';
import { GeneralService } from '../../../services/formulacion/general.service';
import { TraspasoService } from '../../../services/formulacion/traspaso.service';
import { PartidaPresService } from '../../../services/formulacion/partida-pres.service';
import { FusService } from '../../../services/formulacion/fus.service';
import { TareaService } from '../../../services/formulacion/tarea.service';
import { environment } from '../../../../environments/environment';
import { UtilHelper } from '../../../_helpers/util';
import { switchMap } from 'rxjs/operators';
import { UnidadMedidaService } from '../../../services/formulacion/unidad-medida.service';
import { TareaDetalleService } from 'src/app/services/formulacion/tarea-detalle.service';
import { FuenteService } from '../../../services/service.index';
import { parse } from 'querystring';
declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-traspaso-al',
  templateUrl: './traspaso-al.component.html',
  styleUrls: ['./traspaso-al.component.css'],
  providers: [GeneralService, OperacionService, FusService, TareaService, TraspasoService]
})
export class TraspasoAlComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxScrollViewComponent) scrollView: DxScrollViewComponent;
  totalPartidas: number;
  montoTraspasoO: string;
  ttId: number;
  ttotal: number;
  ttotalc: number;
  unidadMedida: any = [];
  popupVisiblePP: boolean = false;
  popupVisibleP: boolean = false;
  tarea_id: number;
  dateActual: Date = new Date();
  scrollByContent = true;
  scrollByThumb = true;
  traspaso_origen_id: number;
  tipo_traspaso_id: number;
  tipo_traspaso_idDestino: number;
  poaTecho: any;
  dataResource: any[];
  dataIntervenciones: any[];
  dataOperaciones: any[];
  dataTareas: any[];
  dataTraspasos: any[] = [];
  dataTipos: any[];
  dataFuentes: any[] = [];
  dataPartidas: any[];
  dataFuenteMeses: any[];
  oTraspasos: any[];
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  popupVisibleEdt: boolean = false;
  popupVisibleSnd: boolean = false;
  popupVisibleChk: boolean = false;
  popupVisibleO: boolean = false;
  clicked: boolean = false;
  state_toogle: boolean = false;
  swFuentes: boolean = false;
  model: any = {
    id: 0,
    justificacion: '',
    traspasos: [],
    intervencion_id: '',
    operacion_id: '',
    tarea_id: '',
    monto_total: 0,
    tipo_traspaso_id: '',
    estado_id: 1,
    fuentes: []
  }
  model2: any = {
    id: 0,
    justificacion: '',
    traspasos: [],
    techo_id: '',
    monto_total: 0,
    tipo_traspaso_id: '',
    estado_id: 1,
    partidas: [],
    adicionaPartida: 0
  }
  detalle: any = {};
  nroValue: string = '';
  baseUrl: string;
  title_modal: string;
  partida_id: string;
  monto_total_liberado: number;
  monto_total_procesado: number;
  monto_total_partida: number;
  monto_total_ingresado: number;
  estado_traspaso: number;
  tabs = [{ id: 1, title: 'TRASPASO ORIGEN' }, { id: 2, title: 'PARTIDAS' }, { id: 3, title: 'ENVIO DE DATOS' }];
  tipoTraspasoFisico: any = [{ id: 6, descripcion: 'Modificación física' }];
  siTab = 0;
  total: number = 0;
  restante: number = 0;
  dTarea: string = '';
  hasError: any;
  idTechoSeleccionado: string;
  partidas: any = [];
  traspaso_destino_id: number = 0;
  rol: number = 0;
  gestionSesionU: number = 0;
  adicionaPartida: number = 0;
  fuente_espejo: number;
  constructor(private route: ActivatedRoute, private _ts: TareaService, private _tds: TareaDetalleService, private _os: OperacionService, private _fs: FusService, private _gs: GeneralService, private _trs: TraspasoService, private _ps: PartidaPresService, private _us: UnidadMedidaService) {
    this.route.paramMap.pipe(switchMap((params: ParamMap) => this.model.intervencion_id = params.get('id'))).subscribe();
    this.route.paramMap.pipe(switchMap((params: ParamMap) => this.model.tipo_traspaso_id = params.get('tipo'))).subscribe();
    this.totalPartidas = 0;
    this.title_modal = '';
    this.fuente_espejo = 0;
    this.ttId = 0;
    this.baseUrl = environment.apiEndpoint;
    this.monto_total_liberado = 0;
    this.monto_total_procesado = 0;
    this.monto_total_partida = 0;
    this.monto_total_ingresado = 0;
    this.estado_traspaso = 0;
    this.poaTecho = {
      descripcion_techo: '',
      techo_unidad_organizacional: '',
      techo_categoria_programatica: '',
      techo_tipo_gasto: '',
      techo_tipo_intervencion: '',
      techo_gestion: ''
    };
    this.gestionSesionU = JSON.parse(localStorage.getItem('g'));
    let u = JSON.parse(localStorage.getItem('u'));
    this.rol = u.rol;

    this.getPoaTecho(this.model.intervencion_id);
    this.clearErrors();
    this.getTraspasos(this.model.intervencion_id);
    this._us.getUnidadMedida().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.unidadMedida = result.data; }
      },
      (error) => { console.log('Error', error); });

    this.fuente_espejo = 0;
  }

  ngOnInit() {
  }

  clearErrors() {
    this.hasError = { intervencion_id: false, operacion_id: false, tarea_id: false, justificacion: false, tipo_traspaso_id: false, partida: false };
  }

  getPoaTecho(intervencion_id: string) {
    this._gs.getPoaTechoById(intervencion_id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.poaTecho = result.data;
        } else {
          this.poaTecho = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  getTraspasos(intervencion_id: string) {
    this._trs.getTraspasosAprobados(intervencion_id, this.model.tipo_traspaso_id).subscribe((response) => {
      let result = UtilHelper.responses(response);
      if (result.status == 200) {
        this.dataResource = result.data;
        this.idTechoSeleccionado = intervencion_id;
      } else {
        this.dataResource = [];
      }
    },
      (error) => { console.log('Error', error); });
  }

  getTareasByOperacionId(e: any) {
    if (e.value != undefined && e.value != null) {
      this.dataFuentes = [];
      this._ts.getListTareasByOperacionId(e.value).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.dataTareas = result.data;
          } else {
            this.dataTareas = [];
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  /**
   * Lista de Tipos de Traspasos
   */
  getTipoTraspasos() {
    if (this.tipo_traspaso_id == 6) {
      this._trs.getTipoTraspaso(this.tipo_traspaso_id).subscribe((response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataTipos = result.data;
        } else {
          this.dataTipos = [];
        }
      },
        (error) => { console.log('Error', error); });
    }
    else {
      this._trs.getTipoTraspaso(0).subscribe((response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataTipos = result.data;
        } else {
          this.dataTipos = [];
        }
      },
        (error) => { console.log('Error', error); });
    }
  }

  inicializar() {
    this.dataTraspasos = [];
    this.restante = 0;
    this.total = 0;

    for (var i = 0; i < this.model2.partidas.length; i++) {
      this.model2.partidas.splice(i, this.model2.partidas.length);
      break;
    }
  }

  /**
   * 
   * @param ev NroTraspaso
   */
  getTraspaso(ev: any) {
    if (ev.keyCode == 13) {
      this._trs.getTraspasoByNro(ev.target.value.toUpperCase(), this.idTechoSeleccionado).subscribe((response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.inicializar();
          let t: string;
          this.tipo_traspaso_id = result.data[0].tipo_traspaso_id;
          this.model.tipo_traspaso_id = this.tipo_traspaso_id;
          if (this.tipo_traspaso_id == 6)
            t = ' - FÍSICO';
          else
            t = ' - PRESUPUESTARIO';
          if (this.dataTraspasos.length > 0) {

            var ind = this.dataTraspasos.findIndex(x => x.nro_traspaso === ev.target.value);
            if (ind == -1) {

              this.dataTraspasos.push(result.data[0]);
              this.tipo_traspaso_idDestino = result.data[0].tipo_traspaso_id;
              this.traspaso_origen_id = result.data[0].id;
              this.model.monto_total = this.dataTraspasos.reduce(function (a, b) { return (parseFloat(a) + parseFloat(b['total_traspaso'])).toFixed(2); }, 0);
              this.title_modal = this.title_modal + t;
            }
          } else {


            this.tipo_traspaso_idDestino = result.data[0].tipo_traspaso_id;
            this.dataTraspasos.push(result.data[0]);
            this.model.monto_total = this.dataTraspasos[0].total_traspaso;
            this.traspaso_origen_id = result.data[0].id;
            this.title_modal = this.title_modal + t;
          }
          this.nroValue = '';


          //Para listar directamente las operaciones
          this.dataOperaciones = [];
          this.dataTareas = [];
          this.dataFuentes = [];
          this.model.operacion_id = '';
          this.model.tarea_id = '';
          this.model.tipo_traspaso_id = this.tipo_traspaso_id;
          if (this.tipo_traspaso_idDestino == 6)
            this.tipo_traspaso_idDestino = 4;
          this._os.getListOperacionesByIntIdA2(this.model.intervencion_id).subscribe(
            (response) => {
              let result = UtilHelper.responses(response);
              if (result.status == 200) {
                this.dataOperaciones = result.data;
              } else {
                this.dataOperaciones = [];
              }
            },
            (error) => { console.log('Error', error); });

        } else if (result.status == 206) {
          toastr.warning(result.data);
        } else if (result.status == 201) {
          toastr.warning("Se tiene registrado un Traspaso con ese número: ");
        } else {
          this.dataResource = [];
          toastr.warning('El traspaso no se encuentra disponible.');
        }
      },
        (error) => {
          if (error.status == 404) {
            toastr.info('El traspaso no está disponible, o no existe.');
          }
        });
    }
  }

  showModalAdd() {
    this.traspaso_destino_id = 0;
    this.title_modal = 'NUEVA ASIGNACIÓN';
    this.nroValue = '';
    this.clearErrors();
    this.model.id = 0;
    this.model.operacion_id = '';
    this.model.tarea_id = '';
    this.model.justificacion = '';
    this.model.tipo_traspaso_id = '';
    this.model.traspasos = [];
    this.model.fuentes = [];
    this.model.monto_total = 0;
    this.model.estado_id = 1;
    this.state_toogle = false;
    this.swFuentes = false;
    this.dataTraspasos = [];
    this.model2.partidas = [];
    this.siTab = 0;
    this.model.traspaso_origen_id = 0;
    this.dataOperaciones = [];
    if (this.gestionSesionU == this.dateActual.getFullYear()) {
      this.popupVisibleAdd = true;

    } else if (this.rol == 23) {
      this.popupVisibleAdd = true;
    }
    else {
      toastr.warning('Debe cambiar a la Gestión ' + this.dateActual.getFullYear() + ' para poder solicitar el Traspaso');
    }

  }

  showModalEdit(id: any) {
    this.traspaso_destino_id = id;
    this.adicionaPartida = 0;
    if (this.gestionSesionU == this.dateActual.getFullYear()) {
      this.dataFuentes = [];
      this.model.monto_total = 0;
      this.getTraspasoById2(id);
      this.title_modal = 'EDITAR TRASPASO';
      this.clearErrors();
      this.state_toogle = true;
      this.siTab = 2;
      this.popupVisibleAdd = true;
      this.getOperaciones(4);
    }
    else {
      toastr.warning('Debe cambiar a la Gestión ' + this.dateActual.getFullYear() + ' para poder solicitar el Traspaso');
    }

  }


  getTraspasoById2(id: number) {
    this._trs.getTraspasoDestinoById2(id).subscribe(
      response => {
        let r = UtilHelper.responses(response);
        if (r.status == 200) {
          this.model2 = r.data;
          this.model.id = r.data.id;
          this.model.tipo_traspaso_id = '';
          this.model.justificacion = r.data.justificacion;
          this.dataTraspasos = r.data.traspasos;
          this.traspaso_origen_id = r.data.traspasos[0].id;
          this.model.tipo_traspaso_id = r.data.tipo_traspaso_id;
          let mt = 0;
          this.dataTraspasos.forEach(function (i) {
            mt += (parseFloat(i.total_traspason));
          });
          this.model.monto_total = mt;
          this.model2.monto_total = mt;
          this.dataFuentes = r.data.fuentes;
          this.swFuentes = false;
        }
        else {
          this.swFuentes = true;
          this.dataFuentes = [];
          this.dataTraspasos = [];
        }
      },
      error => { console.log('Error', error); });
  }

  showModalDelete(id: number) {
    this.model.id = id;
    this.popupVisibleDel = true;
  }

  deleteItem(id: number) {
    var ind = this.dataTraspasos.findIndex(x => x.id === id);
    if (ind != -1) {
      this.dataTraspasos.splice(ind, 1);
      this.model.monto_total = this.dataTraspasos.reduce(function (a, b) { return (parseFloat(a) + parseFloat(b['total_traspaso'])).toFixed(2); }, 0);
    }
  }

  saveTraspaso() {
    this.clearErrors();

    if (this.dataTraspasos.length > 0) {
      this.model.traspasos = this.dataTraspasos;
      this.clicked = true;
      if (this.model2.partidas.length > 0) {
        let suma = 0;
        this.model2.partidas.forEach(i => { suma += parseFloat(i.monto_apropiado); });
        //Validación para que el monto sea igual al introducido
        if (parseFloat(suma.toFixed(2)) == this.model.monto_total) {
          this.model.fuentes = this.dataFuentes;
          this.model2.justificacion = this.model.justificacion;
          this.model2.traspasos = this.model.traspasos;
          this.model2.monto_total = this.model.monto_total;
          this.model2.adicionaPartida = 0;

          if (this.traspaso_destino_id == 0) {
            this.model2.tipo_traspaso_id = this.model.tipo_traspaso_id;
            this.model2.techo_id = this.model.intervencion_id;
            if (this.validate(this.model)) {
              this._trs.postTraspasoDestino2(this.model2).subscribe(
                response => {
                  let result = UtilHelper.responses(response);
                  if (result.status == 200) {
                    this.getTraspasos(this.model.intervencion_id);
                    this.popupVisibleAdd = false;
                    this.clicked = false;
                    toastr.success('Datos guardados exitosamente.');
                  }
                  else {
                    toastr.warning(result.data);
                  }
                },
                error => { console.log('Error', error); });
            }
          }
          else {

            this.model2.tipo_traspaso_id = this.model.tipo_traspaso_id == '' ? this.model2.tipo_traspaso_id : this.model.tipo_traspaso_id;
            if (this.adicionaPartida == 1)
              this.model2.adicionaPartida = 1;
            if (UtilHelper.validator(this.model2.justificacion, 'text')) {
              this._trs.putTraspasoDestino2(this.model2).subscribe(
                response => {
                  let result = UtilHelper.responses(response);
                  if (result.status == 200) {
                    this.getTraspasos(this.model.intervencion_id);
                    this.popupVisibleAdd = false;
                    this.clicked = false;
                    this.adicionaPartida = 0;
                    toastr.success('Datos guardados exitosamente.');
                  }
                },
                error => { console.log('Error', error); });
            }
            else {
              this.hasError.justificacion = true;
              toastr.warning('El traspaso debe tener una justificación.');
            }
          }
        } else {
          toastr.info('Asigne los montos adecuadamente por partida.');
        }
      } else {
        toastr.info('Debe agregar al menos una partida para el envío de datos.');
      }
    } else {
      toastr.warning('Agregue al menos un traspaso origen.');
    }

  }

  validarPartidasExistentes(partidas: any) {
    let res = true;

    const detallesIds = this.dataTraspasos[0].detalles.map(item => item.partida_presupuestaria_id);
    const partidasIds = this.model2.partidas.map(partida => partida.partida_id);

    // Validamos que cada partida_presupuestaria_id exista
    const partidasFaltantes = detallesIds.filter(id => !partidasIds.includes(id));

    if (partidasFaltantes.length > 0) {

      res = false;
    }

    return res;
  }



  deleteTraspaso() {
    this._trs.deleteTraspasoDestino(this.model.id).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getTraspasos(this.model.intervencion_id);
          this.popupVisibleDel = false;
        }
      },
      error => { console.log('Error', error); });
  }

  showModalPrepare(id: number, pjustificacion: string, ptotal: number) {
    let self = this;
    this.popupVisibleEdt = true;
    this.dTarea = '';
    this.model.justificacion = pjustificacion;
    this.partida_id = '';
    this.monto_total_liberado = ptotal;
    this.monto_total_partida = 0;
    this.monto_total_procesado = 0
    this.dataFuenteMeses = [];
    this._trs.getPartidasTraspasoDById(id).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataPartidas = result.data;
          this.dataPartidas.forEach(function (item) {
            self.monto_total_procesado += (parseFloat(item.monto_procesado));
          });
        } else {
          this.dataPartidas = [];
        }
      },
      error => { console.log('Error', error); });
  }

  getFuentesByPartidaId(e: any) {
    this.dataFuenteMeses = [];
    this.monto_total_ingresado = 0;
    if (e.value != null && e.value != '') {
      var ip = this.dataPartidas.findIndex(x => x.id === e.value);
      this.dTarea = '';
      if (ip != -1) {
        this.monto_total_partida = this.dataPartidas[ip].monto;
        //Agregado para mostrar la descripción de la tarea
        this._trs.getDescripcionTareaByTDId(this.dataPartidas[ip].tarea_detalle_id).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) { this.dTarea = result.data; }
          });
      } else {
        this.monto_total_partida = 0;
      }
      this._trs.getFuentesPartidaDById(e.value).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.dataFuenteMeses = result.data;
          } else {
            this.dataFuenteMeses = [];
          }
        },
        error => { console.log('Error', error); });
    }
  }

  calculaTotalFuente(id: number, mes: string) {
    this.monto_total_ingresado = 0;
    var i = this.dataFuenteMeses.findIndex(x => x.id === id);
    if (i != -1) {
      const total_restaA = [
        this.dataFuenteMeses[i].enero_t,
        this.dataFuenteMeses[i].febrero_t,
        this.dataFuenteMeses[i].marzo_t,
        this.dataFuenteMeses[i].abril_t,
        this.dataFuenteMeses[i].mayo_t,
        this.dataFuenteMeses[i].junio_t,
        this.dataFuenteMeses[i].julio_t,
        this.dataFuenteMeses[i].agosto_t,
        this.dataFuenteMeses[i].septiembre_t,
        this.dataFuenteMeses[i].octubre_t,
        this.dataFuenteMeses[i].noviembre_t,
        this.dataFuenteMeses[i].diciembre_t
      ].reduce((acc, val) => acc + parseFloat(val.toString().replace(',', '')), 0);

      const total_resta = parseFloat(total_restaA.toFixed(2));

      if (total_resta > this.monto_total_partida) {
        switch (mes) {
          case 'enero_t':
            this.dataFuenteMeses[i].enero_t = 0;
            break;
          case "febrero_t":
            this.dataFuenteMeses[i].febrero_t = 0;
            break;
          case "marzo_t":
            this.dataFuenteMeses[i].marzo_t = 0;
            break;
          case "abril_t":
            this.dataFuenteMeses[i].abril_t = 0;
            break;
          case "mayo_t":
            this.dataFuenteMeses[i].mayo_t = 0;
            break;
          case "junio_t":
            this.dataFuenteMeses[i].junio_t = 0;
            break;
          case "julio_t":
            this.dataFuenteMeses[i].julio_t = 0;
            break;
          case "agosto_t":
            this.dataFuenteMeses[i].agosto_t = 0;
            break;
          case "septiembre_t":
            this.dataFuenteMeses[i].septiembre_t = 0;
            break;
          case "octubre_t":
            this.dataFuenteMeses[i].octubre_t = 0;
            break;
          case "noviembre_t":
            this.dataFuenteMeses[i].noviembre_t = 0;
            break;
          default:
            this.dataFuenteMeses[i].diciembre_t = 0;
        }

        const total_restaA = [
          this.dataFuenteMeses[i].enero_t,
          this.dataFuenteMeses[i].febrero_t,
          this.dataFuenteMeses[i].marzo_t,
          this.dataFuenteMeses[i].abril_t,
          this.dataFuenteMeses[i].mayo_t,
          this.dataFuenteMeses[i].junio_t,
          this.dataFuenteMeses[i].julio_t,
          this.dataFuenteMeses[i].agosto_t,
          this.dataFuenteMeses[i].septiembre_t,
          this.dataFuenteMeses[i].octubre_t,
          this.dataFuenteMeses[i].noviembre_t,
          this.dataFuenteMeses[i].diciembre_t
        ].reduce((acc, val) => acc + parseFloat(val.toString().replace(',', '')), 0);
        const total_resta = parseFloat(total_restaA.toFixed(2));
        this.dataFuenteMeses[i].monto_t = total_resta;
        const auxFFF = this.monto_total_partida - total_resta;
        this.monto_total_ingresado = parseFloat(auxFFF.toFixed(2));

      } else {
        this.dataFuenteMeses[i].monto_t = total_resta;
        const auxFFF = this.monto_total_partida - total_resta;
        this.monto_total_ingresado = parseFloat(auxFFF.toFixed(2));

      }
    }
  }

  updateProgramacion() {
    if (this.partida_id != '') {
      var total = 0;
      for (var i = 0; i < this.dataFuenteMeses.length; i++) {
        total += parseFloat(this.dataFuenteMeses[i].monto_t);
      }
      if (total == this.monto_total_partida) {
        this._trs.putMesesTraspasoD(this.dataFuenteMeses[0]).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              var index = this.dataPartidas.findIndex(x => x.id === this.partida_id);
              if (index != -1) {
                this.dataPartidas[index].monto_procesado = total;
                this.monto_total_procesado = 0;
                for (var j = 0; j < this.dataPartidas.length; j++) {
                  this.monto_total_procesado += parseFloat(this.dataPartidas[j].monto_procesado);
                }
              }
              this.dataFuenteMeses = [];
              this.partida_id = '';
              this.hasError.partida = false;
              this.refreshDataGrid();
              this.totalPartidas = this.totalPartidas + 1;
              if (this.dataPartidas.length == this.totalPartidas)
                this.popupVisibleEdt = false;
              toastr.success('Montos por mes guardado con exito.');
            }
          },
          error => { console.log('Error', error); });
      } else {
        toastr.info('Ingrese los montos adecuadamente');
      }
    } else {
      this.hasError.partida = true;
    }
  }

  closeModalProgramacion() {
    this.popupVisibleEdt = false;
    this.getTraspasos(this.model.intervencion_id);
  }

  showModalSend(id: number, total_mes: number, total_traspaso: number) {
    this.model.id = id;
    this.model.estado_id = 2;
    this.estado_traspaso = (total_traspaso - total_mes);
    this.popupVisibleSnd = true;
  }

  revisionTraspaso() {
    this._trs.putRevisionTraspasoD(this.model).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getTraspasos(this.model.intervencion_id);
          this.popupVisibleSnd = false;
          toastr.success('Datos enviado a revisión.');
        }
      },
      error => { console.log('Error', error); });
  }

  showModalCheck(id: number, total_mes: number, total_traspaso: number) {
    this.model.id = id;
    this.model.estado_id = 4;
    this.estado_traspaso = (total_traspaso - total_mes);
    this.popupVisibleChk = true;
  }

  aprobarTraspaso() {
    this._trs.putApruebaTraspasoD(this.model).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getTraspasos(this.model.intervencion_id);
          this.popupVisibleChk = false;
          toastr.success('Traspaso aprobado exitosamente.');
        }
      },
      error => { console.log('Error', error); });
  }

  calculaMonto(fuenteId: number, id: number) {
    if (this.model.monto_total > 0) {

      var i = this.dataFuentes.findIndex(x => x.fuente_id === fuenteId);
      if (i != -1) {
        var j = this.dataFuentes[i].partidas.findIndex(y => y.tarea_detalle_financiador_id === id);
        if (j != -1) {
          this.dataFuentes[i].partidas[j].sub_saldo = (parseFloat(this.dataFuentes[i].partidas[j].saldo) + parseFloat(this.dataFuentes[i].partidas[j].monto_apropiado)).toFixed(2);
          var suma = 0;
          for (var ii = 0; ii < this.dataFuentes.length; ii++) {
            suma = parseFloat(suma.toString()) + parseFloat(this.dataFuentes[ii].partidas.reduce(function (a, b) { return (parseFloat(a) + parseFloat(b['monto_apropiado'])).toFixed(2); }, 0));
          }
          if (suma > this.model.monto_total) {
            this.dataFuentes[i].partidas[j].monto_apropiado = 0;
            this.dataFuentes[i].partidas[j].sub_saldo = (parseFloat(this.dataFuentes[i].partidas[j].saldo) + parseFloat(this.dataFuentes[i].partidas[j].monto_apropiado)).toFixed(2);
          }
        }
      }
    } else {
      toastr.info('Agregue los traspasos disponibles');
    }
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  refreshDataGrid() {
    this.getTraspasos(this.model.intervencion_id);
    this.dataGrid.instance.refresh();
  }

  validate(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.intervencion_id, 'integer')) {
      this.hasError.intervencion_id = true; res = false;
    }
    if (!UtilHelper.validator(data.operacion_id, 'integer')) {
      this.hasError.operacion_id = true; res = false;
    }
    if (!UtilHelper.validator(data.tarea_id, 'integer')) {
      this.hasError.tarea_id = true; res = false;
    }
    if (!UtilHelper.validator(data.justificacion, 'text')) {
      this.hasError.justificacion = true; res = false;
      toastr.warning('Debe registrar la justificación en la pestaña - Envío de Datos');
    }
    if (!UtilHelper.validator(data.tipo_traspaso_id, 'integer')) {
      this.hasError.tipo_traspaso_id = true; res = false;
    }
    return res;
  }

  showModalObs(id: number) {
    this._trs.getTraspasoSeguimientoById({ id: id, tipo: 'D' }).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.oTraspasos = result.data;
        } else {
          this.oTraspasos = [];
        }
      });
    this.popupVisibleO = true;
  }

  getOperaciones(e: number) {

    this.tipo_traspaso_idDestino = e;
    if (this.tipo_traspaso_idDestino == 6)
      this.tipo_traspaso_idDestino = 4;


    if (this.tipo_traspaso_idDestino != 0) {
      this.dataOperaciones = [];
      this.dataTareas = [];
      this.dataFuentes = [];
      this.model.operacion_id = '';
      this.model.tarea_id = '';
      this._os.getListOperacionesByTechoId(this.model.intervencion_id).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.dataOperaciones = result.data;

          } else {
            this.dataOperaciones = [];
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  getFuentesByTareaId(e: any) {
    if (e.value != undefined && e.value != null && e.value != '') {
      this.tarea_id = e.value;
      if (this.model.tipo_traspaso_id == 6) {
        this._trs.getPartidasTraspasoFisico(e.value, this.traspaso_origen_id).subscribe(
          (response) => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.dataFuentes = result.data;
              if (this.dataFuentes.length == 0) {
                this.swFuentes = true;
              } else {
                this.swFuentes = false;
              }
            } else {
              this.dataFuentes = [];
            }
          },
          (error) => { console.log('Error', error); });
      } else {
        this._trs.getPartidasTraspasoPpto(e.value, this.traspaso_origen_id, this.model.intervencion_id, this.fuente_espejo).subscribe(
          (response) => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.dataFuentes = result.data;
              if (this.dataFuentes.length == 0) {
                this.swFuentes = true;
              } else {
                this.swFuentes = false;
              }
            } else {
              this.dataFuentes = [];
            }
          },
          (error) => { console.log('Error', error); });
      }
    }
  }

  validaPartida(fuente: string, organismo: string, p: any) {
    if (p.monto_apropiado > 0) {
      if (this.model.tipo_traspaso_id != 6) {
        //valida que no existan partidas iguales a la partida de Origen
        this._trs.postValidaPartida({ partida_id: p.partida_id, traspasos: this.dataTraspasos, tarea_id: this.tarea_id }).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {

              let detalles = this.dataTraspasos[0].detalles;
              let sumaIngresada = 0;
              let sumaPartidas = 0;
              detalles.forEach(item => {

                sumaPartidas += parseFloat(item.sum);
                sumaIngresada = this.model2.partidas
                  .reduce((acc, partida) => acc + partida.monto_apropiado, 0);
                sumaIngresada += p.monto_apropiado;
              });
              if (sumaIngresada > sumaPartidas) {
                toastr.warning(`La suma total de montos agregados no puede ser mayor al monto Liberado: ${sumaPartidas}.`);
              } else {
                this.addCart(fuente, organismo, p);
                this.adicionaPartida = 1;
              }
            }
            else if (result.status == 201) {
              toastr.warning('No es posible realizar traspasos a las mismas Partidas.');
            }
          });
      }
      else {
        let detalles = this.dataTraspasos[0].detalles;
        detalles.forEach(item => {

          if (item.partida_presupuestaria_id === p.partida_id) {
            // Calculamos la suma total de los montos apropiados de la lista por partida_id
            let sumaIngresada = this.model2.partidas
              .filter(partida => partida.partida_id === p.partida_id)
              .reduce((acc, partida) => acc + partida.monto_apropiado, 0);
            sumaIngresada += p.monto_apropiado;
            // Validamos si la suma excede el valor permitido (item.sum)
            if (sumaIngresada > item.sum) {
              toastr.warning('La suma de montos por partida no puede ser mayor al liberado: ' + item.sum);
            } else {
              this._trs.getObtenerMontoTraspasoOporTDFinanciador(p.tarea_detalle_financiador_id, this.traspaso_origen_id).subscribe(
                response => {
                  let result = UtilHelper.responses(response);
                  if (result.status == 200) {
                    this.montoTraspasoO = result.data;
                    if ((parseFloat(this.montoTraspasoO) > 0) && (parseFloat(this.montoTraspasoO) < parseFloat(p.monto_apropiado))) {
                      toastr.warning('El monto no puede ser mayor al liberado: ' + this.montoTraspasoO);
                    } else {
                      this.addCart(fuente, organismo, p);
                    }
                  } else if (result.status == 201) {
                    toastr.warning('No es posible realizar traspasos a las mismas Partidas.');
                  }
                });
            }
          }
        });
      }
    }
    else {
      toastr.warning('El monto no puede ser: 0');
    }
  }

  validarMontoPorPartida(p: any) {
    let res = true;

    return res;
  }


  addCart(fuente: string, organismo: string, p: any) {
    let a: any = this.model2.partidas.filter(item => item.tarea_detalle_financiador_id == p.tarea_detalle_financiador_id).map(item => item);
    if (a.length > 0) {
      for (var i = 0; i < this.model2.partidas.length; i++) {
        if (this.model2.partidas[i].tarea_detalle_financiador_id == p.tarea_detalle_financiador_id) {
          this.model2.partidas[i].monto_apropiado = p.monto_apropiado;
          break;
        }
      }
    }
    else {
      this.model2.partidas.push(
        {
          operacion_id: this.model.operacion_id,
          tarea_id: this.model.tarea_id,
          fuente: fuente,
          organismo: organismo,
          codigo_partida: p.codigo_partida,
          descripcion_partida: p.descripcion_partida,
          saldo: p.saldo,
          monto_apropiado: p.monto_apropiado,
          tarea_detalle_financiador_id: p.tarea_detalle_financiador_id,
          cantidad_apropiada: p.cantidad_apropiada,
          partida_id: p.partida_id
        }
      );
    }
    this.calculaTotal();
    toastr.info('Partida adicionada correctamente, revise la pestaña "ENVÍO DE DATOS".');
  }

  removePartida(id: number) {
    for (var i = 0; i < this.model2.partidas.length; i++) {
      if (this.model2.partidas[i].tarea_detalle_financiador_id == id) {
        this.model2.partidas.splice(i, 1);
        break;
      }
    }
  }

  borrarTemporales() {
    this.model2.partidas = [];
    this.popupVisibleAdd = false
  }

  calculaTotal() {
    let t = 0;
    this.model2.partidas.forEach(i => { t += parseFloat(i.monto_apropiado); });
    this.total = parseFloat(t.toFixed(2));
    this.restante = this.model.monto_total - this.total;
  }

  calculaMonto2(id: number) {
    if (this.model.monto_total > 0) {
      let t = 0;
      let index = 0;
      //this.model2.partidas.forEach(i => { t += parseFloat(i.monto_apropiado); });
      for (var i = 0; i < this.model2.partidas.length; i++) {
        t += parseFloat(this.model2.partidas[i].monto_apropiado);
        if (this.model2.partidas[i].tarea_detalle_financiador_id == id) index = i;
      }
      if (parseFloat(t.toFixed(2)) > this.model.monto_total) {
        this.model2.partidas[index].monto_apropiado = 0;
      }
    } else {
      toastr.info('Agregue al menos un traspaso origen disponible.');
    }
  }

  showModalAddPP(id: number) {
    if (id != 0) {

      this._tds.getTareaDetallePresupuestoById(id).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this._ps.getPartidaPresTipoTraspaso(this.traspaso_origen_id, this.tipo_traspaso_id, this.model.intervencion_id).subscribe(
              (response) => {
                let result = UtilHelper.responses(response);
                if (result.status == 200) { this.partidas = result.data; }
              },
              (error) => { console.log('Error', error); });
            this.detalle.id = id;
            this.detalle.partida_presupuestaria_id = result.data.partida_presupuestaria_id;
            this.detalle.descripcion_partida = result.data.descripcion_partida;
            this.detalle.justificacion_partida_presupuestaria = result.data.justificacion_partida_presupuestaria;
            this.detalle.unidad_medida_id = result.data.unidad_medida_id;
            this.popupVisiblePP = true;
          }
        },
        (error) => { console.log('Error', error); });

    }
    else {

      this._ps.getPartidaPresTipoTraspaso(this.traspaso_origen_id, this.tipo_traspaso_id, this.model.intervencion_id).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) { this.partidas = result.data; }
        },
        (error) => { console.log('Error', error); });
      this.popupVisiblePP = true;
      this.detalle.id = '';
      this.detalle.partida_presupuestaria_id = '';
      this.detalle.descripcion_partida = '';
      this.detalle.justificacion_partida_presupuestaria = '';
      this.detalle.unidad_medida_id = '';
    }
  }

  getTareaDetalleById(id: number) {
    let self = this;
    let dp: any;

  }

  hideModalDT() {
    this.popupVisiblePP = false;
  }

  getDisplayCod(item) {
    if (!item) {
      return '';
    }

    return `${item.codigo} ${item.titulo}`;
  }


  saveTareaDetalle() {
    if (this.detalle.id == 0) {
      this.detalle.traspaso_origen_id = this.traspaso_origen_id;
      this.detalle.unidad_ejecutora_id = this.poaTecho.unidad_organizacional_id;
      this.detalle.tarea_id = this.tarea_id;
      this.detalle.fuentes = this.dataFuentes;
      if (this.validSavePresupuesto()) {
        this._trs.postPartidaUE(this.detalle).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.fuente_espejo = result.data[0].fuente_espejo
              toastr.success('Presupuesto guardado correctamente.');
              this.popupVisiblePP = false;
              if (this.model.tipo_traspaso_id == 6) {
                this._trs.getPartidasTraspasoFisico(this.tarea_id, this.traspaso_origen_id).subscribe(
                  (response) => {
                    let result = UtilHelper.responses(response);
                    if (result.status == 200) {
                      this.dataFuentes = result.data;
                    } else {
                      this.dataFuentes = [];
                    }
                  },
                  (error) => { console.log('Error', error); });
              } else {
                this._trs.getPartidasTraspasoPpto(this.tarea_id, this.traspaso_origen_id, this.model.intervencion_id, this.fuente_espejo).subscribe(
                  (response) => {
                    let result = UtilHelper.responses(response);
                    if (result.status == 200) {
                      this.dataFuentes = result.data;
                    } else {
                      this.dataFuentes = [];
                    }
                  },
                  (error) => { console.log('Error', error); });

              }
            }
            else {
              toastr.success('falló.');
            }
          },
          (error) => { console.log('Error', error); });

      }
    }
    else {
      if (this.validSavePresupuesto()) {
        this.detalle.id = this.detalle.id;
        this._trs.putPartidaUE(this.detalle).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.popupVisiblePP = false;
              if (this.model.tipo_traspaso_id == 6) {
                this._trs.getPartidasTraspasoFisico(this.tarea_id, this.traspaso_origen_id).subscribe(
                  (response) => {
                    let result = UtilHelper.responses(response);
                    if (result.status == 200) {
                      this.dataFuentes = result.data;
                    } else {
                      this.dataFuentes = [];
                    }
                  },
                  (error) => { console.log('Error', error); });
              } else {
                this._trs.getPartidasTraspasoPpto(this.tarea_id, this.traspaso_origen_id, this.model.intervencion_id, this.fuente_espejo).subscribe(
                  (response) => {
                    let result = UtilHelper.responses(response);
                    if (result.status == 200) {
                      this.dataFuentes = result.data;
                    } else {
                      this.dataFuentes = [];
                    }
                  },
                  (error) => { console.log('Error', error); });

              }
              toastr.success('Datos guardados correctamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }
    }
  }

  validSavePresupuesto() {
    let res = true;
    if (!UtilHelper.validator(this.detalle.partida_presupuestaria_id, 'integer') || this.detalle.partida_presupuestaria_id == 0) {
      this.hasError.partida_presupuestaria_id = true; res = false;
    }
    if (!UtilHelper.validator(this.detalle.descripcion_partida, 'text')) {
      this.hasError.descripcion_partida = true; res = false;
    }
    if (!UtilHelper.validator(this.detalle.unidad_medida_id, 'integer') || this.detalle.unidad_medida_id == 0) {
      this.hasError.unidad_medida_id = true; res = false;
    }
    if ((!UtilHelper.validator(this.detalle.justificacion_partida_presupuestaria, 'text')) || (this.detalle.justificacion_partida_presupuestaria == null)) {
      this.hasError.justificacion_partida_presupuestaria = true; res = false;
    }
    return res;
  }

  showModalPartidas(id: number) {
    this.getPartidasTraspasoById(id, this.ttId == 1 ? 'O' : 'D');
    this.popupVisibleP = true;

  }

  getPartidasTraspasoById(id: number, tipo: string) {
    this._trs.getPartidasTraspasoById(id, tipo).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataPartidas = result.data;
          this.dataPartidas.forEach(function (item) {
            if (item.precio_unitario_t == 0)
              item.precio_unitario_t = item.precio_unitario;

            if (item.precio_unitario_f == 0)
              item.precio_unitario_f = item.precio_unitario;

            if (item.precio_unitario_t != 0) {
              var aux = item.monto / item.precio_unitario_t;
              if (item.cantidad_t == 0)
                item.cantidad_t = (Math.floor(aux * Math.pow(10, 2)) / Math.pow(10, 2));
            }
            else {
              item.cantidad_t = 0;
              item.precio_unitario_t = 0;
            }

            if (item.precio_unitario_f != 0) {

              if (parseFloat(item.saldo) > 0) {
                var auxF = item.saldo / item.precio_unitario_f;
                if (item.cantidad_f == 0)
                  item.cantidad_f = (Math.floor(auxF * Math.pow(10, 2)) / Math.pow(10, 2));
              }
              else {
                item.cantidad_f = 0;
                item.precio_unitario_f = 0;
              }
            }


          });
        }
        else { this.dataPartidas = []; }
      },
      (error) => { console.log('Error', error); });
  }

  savePartidas() {
    if (this.validCantidades()) {
      this._trs.putCantidadesPreciosByTraspaso({ data: this.dataPartidas }).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getTraspasos(this.model.intervencion_id);
            this.popupVisibleP = false;
            toastr.success('Operación realizada exitosamente.');
          }
        },
        error => { console.log('Error', error); });
    }
  }

  validCantidades() {
    let r = true, f1 = false, f2 = false, puf = 0, cf = 0, sf = 0, auxF = 0, put = 0, ct = 0, st = 0, auxT = 0, f3 = false;

    this.dataPartidas.forEach(item => {
      put = parseFloat(item.precio_unitario_t);
      ct = parseFloat(item.cantidad_t);
      st = parseFloat(item.monto);
      //auxT = Math.fround(put * ct) * 100 / 100;
      var auxA = put * ct;
      auxT = (Math.floor(auxA * Math.pow(10, 2)) / Math.pow(10, 2));

      puf = parseFloat(item.precio_unitario_f);
      cf = parseFloat(item.cantidad_f);
      sf = parseFloat(item.saldo);

      //auxF = Math.fround(puf * cf) * 100 / 100;
      var auxFF = puf * cf;
      auxF = (Math.floor(auxFF * Math.pow(10, 2)) / Math.pow(10, 2));

      if ((item.cantidad_t == 0) || (item.precio_unitario_t == 0) || (item.precio_unitario_f < 0) || (item.cantidad_f < 0))
        f1 = true;
      if ((auxT > st) || (auxF > sf) || (puf * 1) > sf || (cf * 1) > sf)
        f2 = true;
      if ((sf != 0) && (auxF == 0))
        f3 = true;
    });

    if (f1) {
      r = false;
      toastr.warning('Complete los datos...');
    }
    if (f2) {
      r = false;
      toastr.warning('El precio unitario * el monto no debe ser mayor al saldo y monto liberado');
    }
    if (f3) {
      r = false;
      toastr.warning('La cantidad y precio unitario Formulado es diferenre al total formulado ');
    }
    return r;
  }


}
